import {CREATE_SESSION, CLOSE_SESSION} from '../constants';

export const createUserSession = (session) => ({
    type: CREATE_SESSION,
    session
});

export const closeUserSession = () => ({
    type: CLOSE_SESSION,
});